import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../config';

@Injectable({
  providedIn: 'root',
})
export class ProizvodiService {
  constructor(private _http: HttpClient) {}

  dohvatiSveProizvode(a: any) {
    return this._http.post(AppConfig.ipAddress + 'artiklPopis', a)
      .pipe(map((res: any) => res));
  }

  artiklUredi(a: any) {
    return this._http.post(AppConfig.ipAddress + 'artiklUredi', a)
      .pipe(map((res: any) => res));
  }

  barkodPopis(a: any) {
    return this._http.post(AppConfig.ipAddress + 'barkodPopis', a)
      .pipe(map((res: any) => res));
  }

  barkodUredi(a: any) {
    return this._http.post(AppConfig.ipAddress + 'barkodUredi', a)
      .pipe(map((res: any) => res));
  }

}